import { IGambitData } from "@nkr/models/gambit-data";
import { GambitType } from "@nkr/models/gambit-type";

export default function extractGambitData (gambitDataList: IGambitData[], gambitType: GambitType) {
    let data: IGambitData = gambitDataList.filter((d) => d.gambitType == gambitType)[0];

    if (data === undefined) {
        data = {
            id: 0,
            gambitType: gambitType,
            collectedData: '',
            insertedDate: null,
            updatedDate: null
        }
    }

    return data;
}